import { FASTButton as l, buttonTemplate as f } from "@matrix42/fast-foundation";
import { attr as o } from "@microsoft/fast-element";
import { buttonStyles as u } from "./button.styles.js";
var d = Object.defineProperty, s = (a, p, n, c) => {
  for (var t = void 0, e = a.length - 1, m; e >= 0; e--)
    (m = a[e]) && (t = m(p, n, t) || t);
  return t && d(p, n, t), t;
};
const i = class i extends l {
  constructor() {
    super(...arguments), this.variant = "primary", this.color = "primary", this.size = "md";
  }
};
i.definition = {
  name: "button",
  template: () => f(),
  styles: u,
  shadowOptions: {
    delegatesFocus: !0
  }
};
let r = i;
s([
  o
], r.prototype, "variant");
s([
  o
], r.prototype, "color");
s([
  o
], r.prototype, "size");
export {
  r as Button
};
